// Random per-browser device ID (anti-abuse: 1 new account per device). Not personal data:
// it is generated here, never derived from the device, and only sent when creating an account.
const KEY = "tiertcg_device_id";
const COOKIE = "tt_did";

function readCookie() {
  const m = document.cookie.match(/(?:^|; )tt_did=([A-Za-z0-9-]{16,64})/);
  return m ? m[1] : "";
}

function newId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  const b = new Uint8Array(16);
  window.crypto.getRandomValues(b);
  return Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
}

/** Returns the device ID, creating and persisting it (localStorage + 2-year cookie) on first visit. */
export function getDeviceId() {
  let id = "";
  try {
    id = localStorage.getItem(KEY) || "";
  } catch {
    /* storage blocked */
  }
  if (!/^[A-Za-z0-9-]{16,64}$/.test(id)) id = readCookie();
  if (!id) id = newId();
  try {
    localStorage.setItem(KEY, id);
  } catch {
    /* storage blocked */
  }
  document.cookie = `${COOKIE}=${id}; max-age=${60 * 60 * 24 * 730}; path=/; SameSite=Lax${
    window.location.protocol === "https:" ? "; Secure" : ""
  }`;
  return id;
}
